"use strict";
import "src/decidim/govbr/fix_foundation_trigger_open_listener";
import "src/decidim/govbr/admin_confirm_danger";
require.context("../../images", true);
document.addEventListener("click", (event) => {
  const target = event.target.closest("[data-confirm][data-confirm-danger]");
  if (!target) {
    return;
  }
  const applyDangerStyle = () => {
    const confirmButton = document.querySelector("[data-confirm-ok]");
    if (!confirmButton) {
      return;
    }
    confirmButton.classList.remove("button__secondary");
    confirmButton.classList.add("button__alert");
  };
  window.setTimeout(applyDangerStyle, 0);
});
(() => {
  const INPUT = ".comment__attach-input";
  const humanSize = (bytes) => {
    if (bytes < 1024) {
      return `${bytes} B`;
    }
    if (bytes < 1024 * 1024) {
      return `${Math.round(bytes / 1024)} KB`;
    }
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };
  const feedbackFor = (input) => {
    const field = input.closest(".comment__field");
    if (!field) {
      return null;
    }
    let feedback = field.nextElementSibling;
    const belongsToInput = (feedback == null ? void 0 : feedback.dataset.attachmentInputId) === input.id;
    if (!(feedback == null ? void 0 : feedback.classList.contains("comment__attach-feedback")) || !belongsToInput) {
      feedback = document.createElement("div");
      feedback.className = "comment__attach-feedback";
      feedback.dataset.attachmentInputId = input.id;
      feedback.setAttribute("aria-live", "polite");
      feedback.hidden = true;
      field.insertAdjacentElement("afterend", feedback);
    }
    return feedback;
  };
  const fileType = (input, filename) => {
    var _a;
    const extension = (_a = filename.match(/\.([^.]+)$/)) == null ? void 0 : _a[1];
    if (extension) {
      return extension.slice(0, 4).toUpperCase();
    }
    return input.dataset.fileLabel || "FILE";
  };
  const removeFileAt = (input, index) => {
    if (typeof DataTransfer === "undefined") {
      input.value = "";
      return;
    }
    const transfer = new DataTransfer();
    Array.from(input.files || []).forEach((file, fileIndex) => {
      if (fileIndex !== index) {
        transfer.items.add(file);
      }
    });
    input.files = transfer.files;
  };
  const render = (input) => {
    const feedback = feedbackFor(input);
    if (!feedback) {
      return;
    }
    const files = Array.from(input.files || []);
    feedback.replaceChildren();
    feedback.hidden = files.length === 0;
    feedback.classList.remove("is-uploading", "is-error");
    if (!files.length) {
      return;
    }
    const header = document.createElement("div");
    header.className = "comment__attach-feedback-header";
    const state = document.createElement("span");
    state.className = "comment__attach-state";
    state.setAttribute("role", "status");
    const selectedLabel = files.length === 1 ? input.dataset.selectedSingleLabel || "file selected" : input.dataset.selectedMultipleLabel || "files selected";
    state.textContent = `${files.length} ${selectedLabel}`;
    header.appendChild(state);
    if (files.length > 1) {
      const clear = document.createElement("button");
      clear.type = "button";
      clear.className = "comment__attach-clear";
      clear.textContent = input.dataset.clearLabel || "Remove attachments";
      clear.addEventListener("click", () => {
        input.value = "";
        render(input);
      });
      header.appendChild(clear);
    }
    const list = document.createElement("ul");
    list.className = "comment__attach-list";
    list.setAttribute("aria-label", state.textContent);
    files.forEach((file, index) => {
      var _a, _b;
      const item = document.createElement("li");
      item.className = "comment__attach-item";
      const visual = document.createElement("span");
      visual.className = "comment__attach-file-icon";
      visual.setAttribute("aria-hidden", "true");
      const attachmentIcon = (_b = (_a = input.closest(".comment__attach")) == null ? void 0 : _a.querySelector("svg")) == null ? void 0 : _b.cloneNode(true);
      if (attachmentIcon) {
        visual.appendChild(attachmentIcon);
      } else {
        visual.textContent = fileType(input, file.name);
      }
      const metadata = document.createElement("span");
      metadata.className = "comment__attach-file-meta";
      const name = document.createElement("strong");
      name.className = "comment__attach-name";
      name.title = file.name;
      name.textContent = file.name;
      const size = document.createElement("small");
      size.className = "comment__attach-size";
      size.textContent = humanSize(file.size);
      metadata.append(name, size);
      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "comment__attach-remove";
      remove.setAttribute("aria-label", `${input.dataset.removeLabel || "Remove file"}: ${file.name}`);
      remove.title = remove.getAttribute("aria-label");
      remove.textContent = "\xD7";
      remove.addEventListener("click", () => {
        removeFileAt(input, index);
        render(input);
      });
      item.append(visual, metadata, remove);
      list.appendChild(item);
    });
    feedback.append(header, list);
  };
  const setUploadState = (input, status) => {
    const feedback = feedbackFor(input);
    if (!feedback || feedback.hidden) {
      return;
    }
    const isUploading = status === "uploading";
    feedback.classList.toggle("is-uploading", isUploading);
    feedback.classList.toggle("is-error", status === "error");
    feedback.querySelectorAll("button").forEach((button) => {
      button.disabled = isUploading;
    });
    const state = feedback.querySelector(".comment__attach-state");
    if (state && isUploading) {
      state.textContent = input.dataset.uploadingLabel || "Uploading attachments\u2026";
    } else if (state && status === "error") {
      state.textContent = input.dataset.uploadErrorLabel || "The files could not be uploaded.";
    }
  };
  document.addEventListener("change", (event) => {
    const input = event.target.closest(INPUT);
    if (input) {
      render(input);
    }
  });
  document.addEventListener("ajax:beforeSend", (event) => {
    var _a, _b;
    const input = (_b = (_a = event.target).querySelector) == null ? void 0 : _b.call(_a, INPUT);
    if (input) {
      setUploadState(input, "uploading");
    }
  });
  document.addEventListener("ajax:error", (event) => {
    var _a, _b;
    const input = (_b = (_a = event.target).querySelector) == null ? void 0 : _b.call(_a, INPUT);
    if (input) {
      setUploadState(input, "error");
    }
  });
  document.addEventListener("ajax:success", (event) => {
    var _a, _b, _c, _d;
    const input = (_b = (_a = event.target).querySelector) == null ? void 0 : _b.call(_a, INPUT);
    if (!input) {
      return;
    }
    const responseText = ((_d = (_c = event.detail) == null ? void 0 : _c[2]) == null ? void 0 : _d.responseText) || "";
    if (!responseText.includes("comments:loaded")) {
      setUploadState(input, "error");
      return;
    }
    input.value = "";
    render(input);
  });
})();
